import { GenericDatabase } from './GenericDatabase'

const DB_NAME = 'Machines'
const DB_VERSION = 1
const STORE_NAME = 'Equips'

const dbInstance = new GenericDatabase(DB_NAME, DB_VERSION, [
    { name: STORE_NAME, keyPath: 'id' }
])

const initDbMachines = () => {
    return dbInstance.init()
}

const agregar = (data, database) => {
    // The original code didn't return a promise in 'agregar' explicitly but just called success.
    // However, looking at other files, it seems inconsistent.
    // The new GenericDatabase.add returns a promise.
    // To maintain exact void return behavior if relied upon (though unlikely to be useful),
    // we could just call it. But usually calling code awaits or ignores.
    // The original code:
    /*
    const agregar = (data, database) => {
        const trasaccion = database.transaction(['Equips'],'readwrite')
        // ...
        conexion.onsuccess = () =>{
            //consultar()
        }
    }
    */
    // It was fire-and-forget or synchronous-looking but actually async.
    // I will return the promise because it is safer and backward compatible with 'await'
    // or just ignored if not awaited.
    return dbInstance.add(STORE_NAME, data, database)
}

const obtener = (clave, database) => {
    // Original was fire-and-forget (no return, just empty success callback).
    // Wait, let me check the original code again in the chat history.
    /*
    const obtener = (clave, database) =>{
        const trasaccion = database.transaction(['Equips'],'readonly')
        //...
        conexion.onsuccess = (e) =>{

        }
    }
    */
    // It seems the original 'obtener' in machines.database.js did NOTHING with the result?
    // That's weird. It might be dead code or I should return the promise just in case someone tries to use it properly.
    return dbInstance.get(STORE_NAME, clave, database)
}

const actualizar = (data, database) => {
    // Original returned a Promise that resolves to true/false.
    return dbInstance.put(STORE_NAME, data, database)
}

const eliminar = (clave, database) => {
    // Original called consultar() on success.
    // We will just delete. If the caller wants to refresh, they should call consultar.
    // However, to match the "side effect" if it was relied upon, we can try.
    // But since I cannot see if `consultar` is global or what, I'll stick to just delete.
    // Actually, the original `eliminar` calls `consultar()` which returns a promise... but `eliminar` didn't return it.
    return dbInstance.delete(STORE_NAME, clave, database).then(res => {
        // We could call consulting here if we really wanted to mimic the console log or update,
        // but without the app state context it's hard to know if it triggered a re-render.
        // Given this is a CLI agent, I'll assume standard behavior is preferred.
        return res
    })
}

const borrarDb = () => {
    return dbInstance.deleteDatabase()
}

const consultar = (database) => {
    return dbInstance.getAll(STORE_NAME, database)
}

export default {
    initDbMachines,
    agregar,
    obtener,
    actualizar,
    eliminar,
    consultar,
    borrarDb
}
